// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContactsFilledSvg from "@fishx/icons-svg/es/asn/ContactsFilled";
import FishxIcon from '../components/FishxIcon';

var ContactsFilled = function ContactsFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContactsFilledSvg
  }));
};

ContactsFilled.displayName = 'ContactsFilled';
export default React.forwardRef(ContactsFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ContactsFilled.js
// module id = 2303
// module chunks = 0